$color-border-color: rgba(0, 0, 0, 0.15);

.timesheetCell__inputs {
  display: flex;
  text-align: center;
  label {
    width: 50px;
    font-size: 0.8rem;

    &:first-child {
      margin-right: 5px;
    }

    input {
      width: 100%;
      border-radius: 5px;
      border: 1px solid $color-border-color;
      padding: 0.7rem 0.5rem;
    }

    .errorOutline {
      border-color: red;
      border-width: 2px;
    }
  }
}

.timesheetCell__hours {
  text-align: center;
}

.timesheetCell__checkbox {
  margin-left: 25px;
  margin-bottom: 20px;
}
